module.exports = __webpack_public_path__ + "img/theme-default.bc15b6e5.png";